webpackJsonp([34],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/work/aquarisk.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rebass = __webpack_require__("./node_modules/rebass/dist/index.js");
	
	var _Details = __webpack_require__("./src/Details/index.js");
	
	var _Details2 = _interopRequireDefault(_Details);
	
	var _link = __webpack_require__("./src/app/components/link/index.js");
	
	var _link2 = _interopRequireDefault(_link);
	
	var _Lead = __webpack_require__("./src/Lead/index.js");
	
	var _Lead2 = _interopRequireDefault(_Lead);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LIMASSOL_WATERBOARD_LINK = _react2.default.createElement(
	  _link2.default,
	  { href: 'http://www.wbl.com.cy/en/page/home', target: '_blank' },
	  'Water Board of Limassol'
	);
	
	var KIOS_LINK = _react2.default.createElement(
	  _link2.default,
	  { href: 'http://www.kios.ucy.ac.cy/', target: '_blank' },
	  'KIOS Research and Innovation Center of Excellence, University of Cyprus'
	);
	
	var tags = ['Web Application', 'React', 'Redux', 'Charts', 'D3.js', 'UI Design', 'CSS'];
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Details2.default,
	      {
	        title: 'Aquarisk',
	        subtitle: 'Water Distribution Systems'
	      },
	      _react2.default.createElement(
	        _Details2.default.Paragraph,
	        { emoji: '\uD83D\uDEB0', title: 'Water monitoring solution' },
	        _react2.default.createElement(
	          _link2.default,
	          { href: 'http://aqualligence.com/', target: '_blank' },
	          'Aqualligence'
	        ),
	        ' develops solutions for the integrated management of water distribution systems. Their innovative products allow for detecting leakages and contaminations in the system, that aim to reduce consumer safety risks and waste of resources.',
	        _react2.default.createElement('br', null),
	        'One of their products, Aquarisk, is a cloud-based platform which receives information from internet-enabled sensors deployed in the network, and uses machine learning algorithms to detect leakages and water contaminations. A web-based interface makes it easy to get an overview of the current state of the network, and act fast in the case of leakage or contamination.'
	      ),
	      _react2.default.createElement(
	        _Details2.default.Paragraph,
	        { emoji: '\u2764\uFE0F', title: 'A real-time web application' },
	        'Water network operators use outdated interfaces that are hard to use and hard to access remotely. Aquarisk was set to change that by providing an easy to use web-based interface. In addition, their aim was to save their clients time, by automating some of the things the network operators do manually and repetitively. Aquarisk reached out to help create a web application that takes a huge amount of sensor data, and presents them in a useful way. We\'ve worked together with Aquarisk to create an application that receives data in real-time and presents augmented information on a map. We\'ve developed interactive charts for presenting the evolution of measurements. The web application communicates with the Aquarisk API to display potential leakages and contaminations in the system.'
	      ),
	      _react2.default.createElement(
	        _Details2.default.Paragraph,
	        { emoji: '\uD83D\uDCB6', title: 'Funded by European Union' },
	        'The Aquarisk project was funded by the European Union, under the Horizon 2020 programme "',
	        _react2.default.createElement(
	          'em',
	          null,
	          'Protection of Urban soft targets and urban critical infrastructures'
	        ),
	        '". The project was conducted in collaboration with the ',
	        LIMASSOL_WATERBOARD_LINK,
	        ' and the ',
	        KIOS_LINK,
	        '.'
	      ),
	      _react2.default.createElement(_Details2.default.Tags, { tags: tags }),
	      _react2.default.createElement(
	        _rebass.Box,
	        { mt: 5 },
	        _react2.default.createElement(_Lead2.default, null)
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-work-aquarisk-js-44867bc5f3613727da83.js